import { SVGProps } from 'react';
import { CONFIG_ICON } from './config-icon';
import { useTheme } from 'hooks/theme';

const ReloadIcon = (props: SVGProps<SVGSVGElement>) => {
  const { theme } = useTheme();
  const config_icon = CONFIG_ICON[theme];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 24 24"
      style={{
        fill: 'none',
        stroke: config_icon.secondary,
        strokeWidth: 2,
        strokeMiterlimit: 10,
      }}
      xmlSpace="preserve"
      {...props}
    >
      <path d="M4.5 9.3c-.3.8-.5 1.8-.5 2.7 0 4.4 3.6 8 8 8 2.4 0 4.5-1.1 6-2.7" />
      <path d="M19.5 14.9c.3-.9.5-1.9.5-2.9 0-4.4-3.6-8-8-8-2.4 0-4.5 1-6 2.7" />
      <path d="m16 11.5 3.5 3.5 3.5-3.5" />
      <path d="M1 12.5 4.5 9 8 12.5" />
    </svg>
  );
};

export default ReloadIcon;
